// 로그인. 배포본은 Cloudflare Access(초대한 이메일 + 메일로 받은 코드), 이 PC 시험 서버는 이메일만 넣는 시험용 로그인
//   배포본: '시작하기' → /api/login(Access 가 지킴) → Cloudflare 로그인 창 → 돌아오면 CF_Authorization 쿠키로 /api/* 가 열린다
import { api } from "./lib";

let devMode = false;

export function setDevMode(v: boolean) {
  devMode = v;
}
export const isDevMode = () => devMode;

export async function loggedIn(): Promise<boolean> {
  if (devMode) return true; // 시험 서버는 로그인 없이 들어간다
  try {
    return (await fetch("/api/me", { credentials: "same-origin" })).ok;
  } catch {
    return false;
  }
}

/** Cloudflare 로그인 창으로 갔다가 지금 보던 화면으로 돌아온다 */
export function login() {
  location.assign(`/api/login?to=${encodeURIComponent(location.hash || "#/")}`);
}

/** 이 PC 시험 서버 전용 */
export async function devLogin(email: string) {
  return api("/api/dev-login", { body: { email } });
}

export async function logout() {
  if (devMode) return api("/api/dev-logout", { body: {} });
  // Access 로그아웃: 이 주소의 쿠키를 지우고 세션을 끝낸다. 화면 안에서 부르고, 안 되면 그 주소로 직접 간다
  await fetch("/cdn-cgi/access/logout", { credentials: "same-origin", redirect: "manual" }).catch(() => {});
  if (await loggedIn()) location.assign("/cdn-cgi/access/logout");
}
